import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'zu',
    fullName: 'Zulu',
    nativeName: 'IsiZulu',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "I-ArgVoid",
    landing_title: "Kukhona Okumangalisayo Okuzayo",
    landing_subtitle: "I-ArgVoid uhlelo lokusebenza nesitudiyo sokuthuthukisa umdlalo. Hlala ubukele, izinto ezintsha ziyeza maduze!",
    select_language: "Khetha Ulimi",
    search_placeholder: "Sesha izilimi...",
    terms_title: "Imigomo Yesevisi",
    policy_title: "Inqubomgomo yobumfihlo",
    cookies_title: "Inqubomgomo Yekhukhi",
    terms_content: `
        <strong>1. Ukwamukelwa Kwemigomo</strong><br>
        Ngokufinyelela i-ArgVoid, le Migomo Yesevisi yamukelwe. Uma le migomo kungavunyelwana ngayo, isevisi akufanele isetshenziswe.<br><br>

        <strong>2. I-Platform Usage</strong>X<br>
        I-ArgVoid kanye nezicelo zayo zinikezwa "njengoba injalo" ngezinjongo zolwazi nezokudala. Isevisi kufanele isetshenziselwe izinjongo ezisemthethweni kuphela.<br>X<br>

        <strong>3. Ukuziphatha Okunqatshelwe</strong><br>
        Ukuxhaphaza ubungozi besayithi, ugaxekile, noma ukuzama ukufinyelela okungagunyaziwe kwingqalasizinda akuvunyelwe ngokuphelele.<br><br>

        <strong>4. Umshwana wokuzihlangula</strong><br>
        Inkundla namasevisi kungase kushintshwe nganoma yisiphi isikhathi ngaphandle kwesaziso. Asikho iwaranti enikeziwe mayelana nesikhathi sokusebenza noma ukutholakala kwesevisi.
    `,
    policy_content: `
        <strong>1. Iqoqo Lolwazi</strong>X<br>
        Inkundla ayidingi ukuqinisekiswa komsebenzisi noma ukudalwa kwe-akhawunti ngalesi sikhathi. Alukho ulwazi lokuhlonza lomuntu siqu (njengamagama noma amakheli e-imeyili) oluqoqwa ezivakashini.<br><br>

        <strong>2. Idatha yokusetshenziswa</strong>X<br>
        Izibalo eziyisisekelo, ezingaziwa zingaqoqwa ukuze kuqondwe ithrafikhi yesayithi futhi kuthuthukiswe izinhlelo zokusebenza. Le datha ayixhunyanisiwe nobunikazi bomsebenzisi ngamunye.<br>X<br>

        <strong>3. Amasevisi Enkampani Yangaphandle</strong><br>
        Abahlinzeki bezinkampani zangaphandle bangase basetshenziselwe izinsiza zokubamba nezibalo. Izinqubo zobumfihlo zalaba bahlinzeki abahlukene zibusa idatha engaziwa ecutshungulwa kungqalasizinda yabo.<br><br>

        <strong>4. Ukuphepha kwedatha</strong><br>
        Izinyathelo zokuphepha ezinengqondo zisetshenziswa ukuze kuvikelwe inkundla. Nokho, ayikho indlela yokudlulisela nge-inthanethi evikeleke ngokuphelele.<br><br>
    `,
    cookies_content: `
        <strong>1. Ayini Amakhukhi kanye Nesitoreji Sendawo?</strong><br>
        Amakhukhi kanye nesitoreji sesiphequluli sendawo amafayela edatha amancane agcinwe kudivayisi ukuze akhumbule izintandokazi zokucushwa kukho konke ukuvakasha.<br><br>

        <strong>2. Sebenzisa i-Purpose</strong>X<br>
        I-Browser LocalStorage isetshenziswa ngokuqinile ukuze ulondoloze izilungiselelo zokumisa, njenge:<br>
        - Izinketho zolimi<br>
        - Ukumiswa kokusetshenziswa kubonwa (isb., isakhiwo noma izilungiselelo zetimu)<br>
        - Inqolobane yohlelo lokusebenza yesikhashana<br><br>

        <strong>3. Ayikho i-Tracking</strong><br>
        Amakhukhi nesitoreji sasendaweni akusetshenziselwa izinjongo zokukhangisa noma zokulandela umkhondo wezinkampani zangaphandle. Yonke idatha egciniwe ingeyomsebenzi oyinhloko wenkundla.<br><br>

        <strong>4. Control</strong><br>
        Idatha yesiphequluli ingasulwa nganoma yisiphi isikhathi ngezilungiselelo zesiphequluli, ezizosetha kabusha noma yikuphi ukucupha kwasendaweni.
    `,
    cookie_consent_text: "Sisebenzisa amakhukhi ayisisekelo ukuze siqinisekise ukuthi iwebhusayithi isebenza ngendlela efanele, njengokugcina isikhathi sakho sisebenza, ukulondoloza okuncamelayo kolimi, nokunye ukucushwa okungokwezifiso.",
    read_policy: "Funda Inqubomgomo Yekhukhi",
    support_title: "Xhumana Nosekelo",
    support_subject_label: "Isihloko",
    support_message_label: "Umlayezo",
    support_submit_button: "Thumela umlayezo",
    support_hint: "Qaphela: Lokhu kuzovula uhlelo lwakho lokusebenza lwe-imeyili oluzenzakalelayo ukuze uthumele umlayezo.",
    support_success_msg: "Ivula uhlelo lwakho lokusebenza lwe-imeyili...",
    support_error_msg: "Yehlulekile ukuthumela umlayezo. Sicela uzame futhi emuva kwesikhathi.",
    explorer_title: "Umhloli",
    history_title: "Umlando",
    animation_title: "Opopayi",
    config_title: "Ukucushwa",
    tool_mouse: "Khetha (Ctrl+M)",
    tool_brush: "Ibhulashi (Ctrl+B)",
    tool_brush_mode: "Guqula Imodi (Iqinile/Icacile)",
    tool_eraser: "Isisuli (Ctrl+E)",
    tool_brush_size: "Lungisa Usayizi Webhulashi",
    tool_bucket: "Gcwalisa (Ctrl+F)",
    tool_eyedropper: "I-Eyedropper",
    tool_grid: "Igridi (Ctrl+Shift+B)",
    tool_rotate: "Zungezisa (Ctrl+Shift+R)",
    tool_flip_h: "Phenya H (Ctrl+Shift+H)",
    tool_flip_v: "Phenya V (Ctrl+Shift+V)",
    tool_transpose: "I-Transpose (Ctrl+Shift+T)",
    label_width: "Ububanzi",
    label_height: "Ubude",
    label_frames: "Inombolo Yozimele",
    label_animation: "Isitayela Sopopayi",
    label_background_color: "Umbala Ongemuva",
    label_interval: "Isikhawu",
    tool_anim_config: "Ukucushwa Kwezithombe Ezinyakazayo",
    label_new_width: "Ububanzi Obusha",
    label_new_height: "Ukuphakama Okusha",
    label_apply: "Faka isicelo",
    label_colors: "Imibala",
    label_size: "Usayizi",
    label_tolerance: "Ukubekezelelana",
    val_horizontal: "Okuvundlile",
    val_vertical: "Iqondile",
    val_sequence: "Ukulandelana",
    val_bounce: "Bounce",
    val_random: "Ngokungahleliwe",
    val_solid: "Okuqinile",
    val_clear: "Kucace",
    action_add_sheet: "Ishidi Elisha",
    action_import: "Ngenisa",
    action_export: "Thekelisa",
    action_sort_projects: "Hlunga",
    sort_date_old: "Omdala Okokuqala",
    sort_date_new: "Okusha Okokuqala",
    sort_name_az: "Igama (A-Z)",
    sort_name_za: "Igama (Z-A)",
    action_new_sprite: "I-Sprite entsha",
    action_new_project: "Iphrojekthi Entsha",
    modal_save_all_title: "Londoloza Zonke Izinguquko",
    modal_save_all_desc: "Khetha amafa ozowalondoloza:",
    modal_save_selected: "Londoloza Okukhethiwe",
    action_saved: "Kulondoloziwe",
    modal_create_sprite_title: "Dala i-Sprite Entsha",
    modal_create_project_title: "Dala Iphrojekthi Entsha",
    modal_add_sheet_title: "Engeza Ishidi Elisha",
    modal_rename_sheet_title: "Qamba kabusha Ishidi",
    modal_rename_sprite_title: "Qamba kabusha i-Sprite",
    modal_delete_sprite_title: "Susa i-Sprite",
    modal_delete_project_title: "Susa Iphrojekthi",
    modal_delete_sheet_title: "Susa Ishidi",
    placeholder_sprite_name: "Igama",
    placeholder_project_name: "Igama",
    placeholder_sheet_name: "Igama",
    placeholder_new_name: "Igama Elisha",
    action_create: "Dala",
    action_add: "Engeza",
    action_rename: "Qamba kabusha",
    action_duplicate: "Impinda",
    action_delete: "Susa",
    action_cancel: "Khansela",
    confirm_delete_sprite: "Uqinisekile ukuthi ufuna ukususa le sprite?",
    confirm_delete_project: "Uqinisekile ukuthi ufuna ukususa le phrojekthi? Wonke ama-sprites azosuswa.",
    confirm_delete_sheet: "Uqinisekile ukuthi ufuna ukususa leli shidi?",
    err_select_sprite: "Sicela ukhethe i-sprite kuqala.",
    err_select_project: "Sicela ukhethe iphrojekthi kuqala.",
    err_name_empty: "Igama alikwazi ukungabi nalutho.",
    err_sprite_exists: "I-sprite enalelo gama isivele ikhona.",
    err_project_exists: "Iphrojekthi enalelo gama isivele ikhona.",
    err_no_content: "Akukho okuqukethwe okungalondolozwa.",
    err_no_changes: "Azikho izinguquko ezingalondolozwa.",
    err_delete_last_sheet: "Ayikwazi ukususa ishidi lokugcina.",
    err_extract_frames: "Ayikwazanga ukukhipha noma yiziphi izinhlaka.",
    err_indexeddb: "Yehlulekile ukulondoloza endaweni. Isiphequluli sakho singase singasekeli i-IndexedDB.",
    msg_upload_success: "Ukulayisha Kuphumelele: {0}",
    msg_upload_failed: "Ukulayisha Kwehlulekile: {0}",
    msg_save_success: "Ukulondoloza kuphumelele.",
    msg_saving: "Iyalondoloza...",
    msg_multi_save_result: "Kulondolozwe amafa angu-{0}. {1} ukwehluleka.",
    menu_title: "Imenyu",
    menu_save: "Londoloza",
    menu_save_all: "Londoloza Konke",
    menu_support: "Xhumana Nosekelo",
    label_local_storage: "Isitoreji Sendawo",
    label_sign_in: "Ngena ngemvume",
    modal_export_title: "Thumela i-Sprite",
    label_filename: "Igama lefayela",
    label_format: "Ifomethi",
    action_export_confirm: "Thekelisa",
};

export default translations;
